import React from "react";
import { FormattedDate } from "react-intl";
import { Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";

export default ({ question }) => {
  return (
    <Grid container justify="flex-start" id={question.id}>
      <Grid item>
        <Grid container direction="column">
          <Grid item>
            <Typography
              variant="body2"
              style={{ textAlign: "left", fontWeight: "400" }}
            >
              {question.modifiedDate && (
                <FormattedDate value={question.modifiedDate} />
              )}
            </Typography>
          </Grid>
          {question.modifiedFirstName && question.modifiedLastName && (
            <Grid item>
              <Typography
                variant="body2"
                style={{
                  textAlign: "left",
                  fontWeight: "400",
                  wordBreak: "break-word",
                }}
              >
                {`${question.modifiedFirstName} ${question.modifiedLastName}`}
              </Typography>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
};
